import React from 'react';

const About = () => {
  return (
    <section id="about" className="section-padding bg-white/70 backdrop-blur-md shadow-lg">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">About Me</h2>
          <div className="w-20 h-1 bg-primary-600 mx-auto"></div>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6 min-w-0">
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
              Data Scientist & Mathematics Enthusiast
            </h3>
            <p className="text-gray-600 leading-relaxed">
              I am a dedicated Applied Mathematics student with a passion for data science 
              and machine learning. Currently pursuing my degree at the University of Tunis El Manar, 
              I have developed expertise in deep learning, statistical analysis, and software development.
            </p>
            <p className="text-gray-600 leading-relaxed">
              My experience includes developing CNN models for medical image analysis, 
              implementing machine learning algorithms, and creating full-stack applications. 
              I'm particularly interested in applying mathematical concepts to solve real-world 
              data problems and building intelligent systems.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-8">
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Location</h4>
                <p className="text-gray-600">Manouba, Tunisia</p>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Email</h4>
                <p className="text-gray-600 break-all">mimounisirine348@email.com</p>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Phone</h4>
                <p className="text-gray-600">+216 58 086 751</p>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Study</h4>
                <p className="text-gray-600">Applied Mathematics</p>
              </div>
            </div>
          </div>
          
          <div className="space-y-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h4 className="text-xl font-semibold text-gray-900 mb-4">
                <i className="fas fa-bullseye text-primary-600 mr-3"></i>
                My Focus
              </h4>
              <ul className="space-y-3">
                <li className="flex items-center text-gray-600">
                  <i className="fas fa-check text-primary-600 mr-3"></i>
                  Deep Learning & Neural Networks
                </li>
                <li className="flex items-center text-gray-600">
                  <i className="fas fa-check text-primary-600 mr-3"></i>
                  Medical Image Analysis
                </li>
                <li className="flex items-center text-gray-600">
                  <i className="fas fa-check text-primary-600 mr-3"></i>
                  Statistical Modeling
                </li>
                <li className="flex items-center text-gray-600">
                  <i className="fas fa-check text-primary-600 mr-3"></i>
                  Full-Stack Development
                </li>
              </ul>
            </div>
            
            <div className="bg-primary-50 p-6 rounded-lg">
              <h4 className="text-xl font-semibold text-gray-900 mb-4">
                <i className="fas fa-heart text-primary-600 mr-3"></i>
                What I Love
              </h4>
              <p className="text-gray-600 leading-relaxed">
                I'm passionate about the intersection of mathematics and technology. 
                I enjoy tackling complex problems, learning new technologies, and 
                collaborating with teams to create innovative solutions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
